/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SuppressTaskOutsideProjectPeriodWarningInput = {|
  projectId: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type suppressTaskOutsideProjectPeriodWarningMutationVariables = {|
  input: SuppressTaskOutsideProjectPeriodWarningInput
|};
export type suppressTaskOutsideProjectPeriodWarningMutationResponse = {|
  +suppressTaskOutsideProjectPeriodWarning: ?{|
    +viewer: ?{|
      +id: string
    |}
  |}
|};
export type suppressTaskOutsideProjectPeriodWarningMutation = {|
  variables: suppressTaskOutsideProjectPeriodWarningMutationVariables,
  response: suppressTaskOutsideProjectPeriodWarningMutationResponse,
|};
*/


/*
mutation suppressTaskOutsideProjectPeriodWarningMutation(
  $input: SuppressTaskOutsideProjectPeriodWarningInput!
) {
  suppressTaskOutsideProjectPeriodWarning(input: $input) {
    viewer {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SuppressTaskOutsideProjectPeriodWarningInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTaskOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTaskOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "suppressTaskOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTaskOutsideProjectPeriodWarningMutation(\n  $input: SuppressTaskOutsideProjectPeriodWarningInput!\n) {\n  suppressTaskOutsideProjectPeriodWarning(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c417f55025459d0fdb296cbd76264d39';

module.exports = node;
